function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable max-classes-per-file */
import { EventTarget } from 'event-target-shim';
import { Log } from '@deephaven/log';
import { EventShimCustomEvent } from '@deephaven/utils';
import Shortcut from "./Shortcut.js";
var log = Log.module('ShortcutRegistry');
class ShortcutRegistry extends EventTarget {
  constructor() {
    super(...arguments);
    _defineProperty(this, "shortcutMap", new Map());
    _defineProperty(this, "shortcutsByCategory", new Map());
  }
  /**
   * Creates a Shortcut and adds it to the registry
   * @param params The constructor params for the {@link Shortcut}
   * @returns The created shortcut or the shortcut in the registry if 1 already exists w/ the same ID
   */
  createAndAdd(params) {
    var shortcut = new Shortcut(params);
    return this.add(shortcut);
  }

  /**
   * Adds a shortcut to the registry. Warns and returns existing shortcut if a shortcut with the same ID already exists
   * @param shortcut Shortcut to add to the registry
   * @returns Shortcut passed if it is not in the registry. Shortcut from the registry if one exists for the same ID
   */
  add(shortcut) {
    var existingShortcut = this.shortcutMap.get(shortcut.id);
    if (existingShortcut) {
      log.warn("Skipping attempt to add duplicate shortcut ID to registry: ".concat(shortcut.id));
      return existingShortcut;
    }
    log.debug2("Adding shortcut to registry: ".concat(shortcut.id));
    shortcut.addEventListener('onUpdate', _ref => {
      var detail = _ref.detail;
      return this.dispatchEvent(new EventShimCustomEvent('onUpdate', {
        detail
      }));
    });
    var category = shortcut.id.split('.')[0];
    this.shortcutMap.set(shortcut.id, shortcut);
    if (this.shortcutsByCategory.has(category)) {
      var _this$shortcutsByCate;
      (_this$shortcutsByCate = this.shortcutsByCategory.get(category)) === null || _this$shortcutsByCate === void 0 || _this$shortcutsByCate.push(shortcut);
    } else {
      this.shortcutsByCategory.set(category, [shortcut]);
    }
    return shortcut;
  }

  /**
   * Gets a shortcut from the registry from an ID
   * @param id ID of the shortcut
   * @returns The shortcut for that ID if it exists
   */
  get(id) {
    return this.shortcutMap.get(id);
  }

  /**
   * Gets an array of any registered shortcuts with conflicting key states.
   * Only checks the key states of the current OS (Mac or Windows/Linux)
   * @param keyState
   * @returns Array of conflicting shortcuts. Empty array if none conflict
   */
  getConflictingShortcuts(keyState) {
    return Array.from(this.shortcutMap.values()).filter(shortcut => !shortcut.isNull() && shortcut.matchesKeyState(keyState));
  }
}
var registry = Object.freeze(new ShortcutRegistry());
export default registry;
//# sourceMappingURL=ShortcutRegistry.js.map